import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=69ff1e34&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/AboutUs-pc.css?vue&type=style&index=0&id=69ff1e34&scoped=true&lang=css&"
import style1 from "../assets/css/AboutUs-phone.css?vue&type=style&index=1&id=69ff1e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ff1e34",
  null
  
)

export default component.exports